
class SearchBarParams {
  constructor(data) {
    const {
      ...rest
    } = data ?? {};
    Object.keys(rest).forEach((key) => (this[key] = rest[key]));
  }
}

export default SearchBarParams;
